'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import styles from './FooterSearch.styles.js';
import { FooterSearchFallback } from './slots/FooterSearchFallback/FooterSearchFallback.js';

var COMPONENT_ID = "FooterSearch";
var defaultProps = {
    placeholder: "Поиск по сайту",
    withBorder: false,
    styles: styles,
    renderSearchFallback: function() {
        return /*#__PURE__*/ jsx(FooterSearchFallback, {
            description: "Проверьте запрос и попробуйте ещё раз",
            title: "Ничего не найдено"
        });
    }
};

export { COMPONENT_ID, defaultProps };
